/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiIncrementalityTestStatus;
(function (ApiIncrementalityTestStatus) {
    ApiIncrementalityTestStatus["INCREMENTALITY_TEST_STATUS_UNSPECIFIED"] = "IncrementalityTestStatusUnspecified";
    ApiIncrementalityTestStatus["INCREMENTALITY_TEST_STATUS_DRAFT"] = "IncrementalityTestStatusDraft";
    ApiIncrementalityTestStatus["INCREMENTALITY_TEST_STATUS_ACTIVE"] = "IncrementalityTestStatusActive";
})(ApiIncrementalityTestStatus || (ApiIncrementalityTestStatus = {}));
export function ApiIncrementalityTestStatusFromJSON(json) {
    return ApiIncrementalityTestStatusFromJSONTyped(json, false);
}
export function ApiIncrementalityTestStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiIncrementalityTestStatusToJSON(value) {
    return value;
}
